<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab v-if="Core.Validation.isId(dataId)">
                <template slot="title">
                    <i class="fa fa-edit mr-2"></i>{{Core.Definition.getDefinition('Structure')}}
                </template>
                <b-row class="p-3">
                    <b-col>
                        <BinderTemplateStructure v-model="dataId"></BinderTemplateStructure>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <i class="fa fa-cogs mr-2"></i>{{Core.Definition.getDefinition('Configurations')}}
                </template>
                <b-row class="p-3">
                    <b-col>
                        <DynamicForm
                                v-model="dataId"
                                ref="dynamicForm"
                                getRoot="/binder-template"
                                saveRoot="/binder-template"
                                @onRequestSuccess="onRequestSuccess"
                                @onTrashClick="onTrashClick"
                                @onSaveSuccess="onSaveSuccess"
                                :formStructure="dataFormStructures.binder">
                        </DynamicForm>
                        <ModalTrash
                                ref="trash"
                                root="/binder-template"
                                @onTrashSuccess="onTrashSuccess"
                                :caption="Core.Definition.getDefinition('Suppression du classeur')"
                                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce classeur?')"></ModalTrash>
                    </b-col>
                </b-row>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import BinderTemplateStructure from './BinderTemplateStructure'
    export default {
        name: 'BinderTemplate',
        components: {
            DynamicForm,
            ModalTrash,
            BinderTemplateStructure
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataTitle: '',
                dataFormStructures: {
                    binder: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Classeur'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'singularTitle'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'plurialTitle'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'icon'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Libellé'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'addNewLabel'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'editLabel'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'listLabel'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('PDF'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfTemplate'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Entête PDF'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfHeaderImage'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfHeaderImageSize'
                                                                    }
                                                                ]
                                                            },
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfHeaderBranch'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfHeaderText'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfTemplate'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Pied de page PDF'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfFooterImage'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'pdfFooterImageSize'
                                                                    }
                                                                ]
                                                            },
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'singularTitle',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre singulier'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'description',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'icon',
                                type: Core.Value.typeText,
                                label: Core.Definition.getDefinition('Icône'),
                                value: 'fa fa-folder',
                                description: Core.Definition.getDefinition('Les icônes sont basées sur fontawesome. Retrouvez toutes les icônes ici: https://fontawesome.com/')
                            },
                            {
                                id: 'plurialTitle',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre pluriel'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'addNewLabel',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ajouter un nouveau'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'editLabel',
                                type: 'text',
                                label: Core.Definition.getDefinition('Modifier'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'listLabel',
                                type: 'text',
                                label: Core.Definition.getDefinition('Liste'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'color',
                                type: 'color',
                                mode: 'sketch',
                                label: Core.Definition.getDefinition('Couleur'),
                                value: {}
                            },
                            {
                                id: 'pdfFooterImage',
                                type: 'image',
                                label: Core.Definition.getDefinition('Image de pied de page'),
                                value: []
                            },
                            {
                                id: 'pdfFooterImageSize',
                                type: 'text',
                                label: Core.Definition.getDefinition('Taille de l\'image de pied de page'),
                                description: Core.Definition.getDefinition('Valeur en pixel (px) ou en pourcentage (%)'),
                                value: ''
                            },
                            {
                                id: 'pdfHeaderImage',
                                type: 'image',
                                label: Core.Definition.getDefinition('Image de l\'entête'),
                                value: []
                            },
                            {
                                id: 'pdfHeaderImageSize',
                                type: 'text',
                                label: Core.Definition.getDefinition('Taille de l\'image de l\'entête'),
                                description: Core.Definition.getDefinition('Valeur en pixel (px) ou en pourcentage (%)'),
                                value: ''
                            },
                            {
                                id: 'pdfHeaderText',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Texte de l\'entête'),
                                value: ''
                            },
                            {
                                id: 'pdfHeaderBranch',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Adresse(s) succursale(s)'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'pdfTemplate',
                                type: 'text',
                                label: Core.Definition.getDefinition('Modèle du PDF'),
                                value: 'default'
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onRequestSuccess(data) {
              if(data.form!==undefined) {
                  if (data.form.singularTitle!==undefined) {
                      this.dataTitle = data.form.singularTitle
                  }
              }
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/classeur/modeles')
            },
            onSaveSuccess(data) {
                if (data.binder !== undefined) {
                    let binderIndex = Core.Session.hasBinder(data.binder.slug)
                    if (binderIndex !== false) {
                        Core.Session.binders[binderIndex] = data.binder
                    } else {
                        Core.Session.binders.push(data.binder)
                    }
                    this.$parent.$parent.$refs.sidebarNav.resetNav()
                }
            },
            onRequestSuccessPDF() {
                this.$refs.binderPDFStampList.retrieve()
            },
            onClickAddStampPDF() {
                this.$refs.modalBinderPDFStamp.open = true
            },
            onClickEditStampPDF(value, cell, row) {
                this.dataBinderPDFStampId = row.id
                this.$refs.modalBinderPDFStamp.open = true
            },
            onClickAddSignaturePDF() {
                this.$refs.modalBinderPDFSignature.open = true
            },
            onClickEditSignaturePDF(value, cell, row) {
                this.dataBinderPDFSignatureId = row.id
                this.$refs.modalBinderPDFSignature.open = true
            }
        }
    }
</script>
